    <template>
    <vx-card id="loader">
        <vs-row vs-w="12">
            <vs-col vs-offset="0" vs-type="flex" vs-justify="left" vs-align="center" vs-w="6">
                <div class="vx-row mb-4">
                    <h4 class="float-left">Статистика</h4>
                    <feather-icon
                        @click="showPopup()"
                        icon="HelpCircleIcon"
                        class="text-info vopros cursor-pointer page-description"
                        svgClasses="w-5 h-5"
                    />
                </div>
                <vs-popup title="Подробнее" v-if="popupContent" :active.sync="popupIsVisible"><span v-html="popupContent"></span></vs-popup>
            </vs-col>
        </vs-row>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/4">
                <label class="vs-input--label"> Дата </label>
                <date-picker
                    :not-before="disabledBefore"
                    :not-after="disabledAfter"
                    range
                    v-model="dateInterval"
                    value-type="format"
                    format="YYYY-MM-DD"
                    placeholder="Выберите дату"
                    :lang="'ru'"
                    :firstDayOfWeek="1"
                    class="date-p w-full"
                >
                </date-picker>
            </div>
            <div class="vx-col mt-1">
                <vs-button class="mt-2 submit-button" color="success" @click="loadStatistic()" type="filled"> Применить </vs-button>
            </div>
            <div class="vx-col w-1/4">
                <label class="vs-input--label"> Дата обновления </label>
                <date-picker
                    :not-before="disabledBefore"
                    :not-after="disabledAfter"                    
                    v-model="form.updateDate"
                    value-type="format"
                    format="YYYY-MM-DD"
                    placeholder="Выберите дату"
                    :lang="'ru'"
                    :firstDayOfWeek="1"
                    class="date-p w-full"
                >
                </date-picker>
            </div>
            <div class="vx-col mt-1">
                <vs-button class="mt-2 submit-button" color="primary" @click="updateStatistic()" type="filled"> Обновить статистику </vs-button>
            </div>
        </div>

        <div class="vx-row">
            <div class="vx-col w-full">
                <vs-table :data="items" max-items="10">
                    <template slot="thead">
                        <vs-th> Id пользователя</vs-th>
                        <vs-th> Email</vs-th>
                        <vs-th> Id партнера</vs-th>
                        <vs-th> Показы</vs-th>
                        <vs-th> Клики</vs-th>
                        <vs-th> Лиды</vs-th>
                        <vs-th> Одобренные лиды</vs-th>
                        <vs-th> Доход (USD)</vs-th>
                        <vs-th> Доход Адпрофекс</vs-th>
                    </template>

                    <template slot-scope="{ data }">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>{{ tr.userId }}</vs-td>
                            <vs-td>{{ tr.email }}</vs-td>
                            <vs-td>{{ tr.partnerId }}</vs-td>
                            <vs-td>{{ tr.buyouts }}</vs-td>
                            <vs-td>{{ tr.clicks }}</vs-td>
                            <vs-td>{{ tr.leadsCount }}</vs-td>
                            <vs-td>{{ tr.leadsConfirmedCount }}</vs-td>
                            <vs-td>{{ tr.profitUsd }}</vs-td>
                            <vs-td>{{ tr.profitUsd * 0.6 | formatNumber(2) }}</vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </div>
        <vs-pagination :max="5" :total="pagesTotal" v-model="page"></vs-pagination>
    </vx-card>
</template>

<script>
import vSelect from 'vue-select';
import axios from 'axios';
import qs from 'qs';
import DatePicker from 'vue2-datepicker';
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';

let startPeriod = new Date(2023, 4, 9); // Дата начала сбора метрик
let endPeriod = new Date().setDate(new Date().getDate() - 1); // Максимальный период до вчерашней даты
export default {
    data() {
        return {
            popupIsVisible: false,
            popupContent: '',

            page: 1,
            pageSize: 100,
            pagesTotal: 1,

            disabledBefore: startPeriod,
            disabledAfter: endPeriod,
            dateInterval:undefined,

            items: [],
            form: {
                updateDate: undefined,
                date_time_from: undefined,
                date_time_to: undefined,
            },
            dicts: {
                users: [],
                pageSizes: [25, 50, 100, 500]
            },
            errors: {
                users: ''
            }
        };
    },
    mounted() {
        this.loadDicts();
        this.setDefaultValues();
        this.loadStatistic();
    },
    methods: {
        loadDicts() {
            this.axios.get('partners-network/Statistic/dicts').then((dicts) => {
                this.dicts.users = dicts.data.users;
            });
        },
        loadStatistic() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const params = {
                dateFrom: this.form.date_time_from,
                dateTo: this.form.date_time_to,
                page: this.page,
                size: this.pageSize
            };

            this.axios
                .all([
                    this.axios.get('partners-network/statistic', {
                        params: params,
                        paramsSerializer: (params) => {
                            return qs.stringify(params, { arrayFormat: 'repeat' });
                        }
                    })
                ])
                .then(
                    axios.spread((items) => {
                        this.items = items.data;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        updateStatistic() {
            this.$vs.notify({
                        title: 'Выполняется!',
                        text: 'Обновление займет 1 миниту.',
                        color: 'warning'
                    });
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });
            const params = {
                updateDate: this.form.updateDate,
            };

            this.axios
                .all([this.axios.put('partners-network/statistic', params)])
                .then(
                    axios.spread(() => {
                        this.loadStatistic();
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        showPopup() {
            this.popupContent = 'Данные загруженные из трекера';
            this.popupIsVisible = true;
        },
        setDefaultValues() {
            let d = new Date();
            let yesterday = this.$moment(d.setDate(d.getDate() - 1)).format('YYYY-MM-DD');                        
            let endDayStr = yesterday;            
            let startDayStr = yesterday;
            this.dateInterval = [startDayStr, endDayStr];
            this.form.date_time_from = this.$moment(this.dateInterval[0]).format('YYYY-MM-DD');
            this.form.date_time_to = this.$moment(this.dateInterval[1]).format('YYYY-MM-DD');

            this.form.updateDate = yesterday;
        }
    },
    components: {
        'v-select': vSelect,
        'date-picker': DatePicker,
        SweetModal,
        SweetModalTab
    },
    watch: {
        dateInterval: function (newTime) {
            this.form.date_time_from = this.$moment(newTime[0]).format('YYYY-MM-DD');
            this.form.date_time_to = this.$moment(newTime[1]).format('YYYY-MM-DD');
        }
    }
};
</script>
<style lang="scss">
table {
    tr.selected {
        cursor: text !important;
    }
}

.header-title {
    flex-direction: column;
}

.vs-con-table .vs-con-tbody,
.vs-table--content {
    overflow: initial;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
    -webkit-transform: none;
}

.vs-pagination-primary,
.submit-button {
    margin-top: 15px !important;
}

.td.vs-table--td {
    width: 5%;
    border: 1px solid rgba(0, 0, 0, 0.12);
    padding: 4px 5px !important;
    text-align: right;
    font-family: sans-serif;
    font-size: 16px !important;
}

div.vs-table-text {
    text-align: right;
    float: right;
}
</style>